import { teamContext } from "@redotech/feature-flags-model/context";
import { featureFlag } from "@redotech/openfeature-contracts/flag";

/**
 * Offer iMessage enablement: admin "Allow iMessage" and Recover toggles, and
 * iMessage in Commerce Agent onboarding. Teams already on iMessage keep it.
 */
export const imessageEnablementFlag = featureFlag(
  "imessage-enablement",
  teamContext,
).boolean(false);

/** The TikTok Ads audience-sync integration (connect + sync). */
export const tiktokAdsIntegrationFlag = featureFlag(
  "tiktok-ads-integration",
  teamContext,
).boolean(false);

/** The Uptick offer-network integration (tile, settings entry, provider option). */
export const uptickIntegrationFlag = featureFlag(
  "uptick-integration",
  teamContext,
).boolean(false);

/** The Disco offer-network integration (tile, settings entry, provider option). */
export const discoIntegrationFlag = featureFlag(
  "disco-integration",
  teamContext,
).boolean(false);

/** Email address filtering in marketing segments. */
export const segmentEmailDomainFilterFlag = featureFlag(
  "marketing-segment-email-domain-filter",
  teamContext,
).boolean(false);

/** The dynamic table block in the email builder's block picker. */
export const emailTableBlockFlag = featureFlag(
  "email-table-block",
  teamContext,
).boolean(false);

/** The beta Discounts UI in the merchant marketing navigation. */
export const discountUiFlag = featureFlag("discount-ui", teamContext).boolean(
  false,
);

/** Custom Reports under Marketing Analytics. */
export const marketingAnalyticsCustomReportsFlag = featureFlag(
  "marketing-analytics-custom-reports",
  teamContext,
).boolean(false);
